// External Imports
import { useState } from "react";
import { AiOutlinePlusCircle } from "react-icons/ai";

// Internal Imports
import { useVendors } from "hooks/useVendors";
import LocationModal from "components/LocationModal";
import LocationList from "components/LocationList";
import DeleteModal from "components/DeleteModal";
import GoogleMap from "components/Map";

const Vendors = () => {
  const { vendors, createVendor, updateVendor, deleteVendor } = useVendors();
  const [selectedIndex, setSelectedIndex] = useState(null);
  const selected = vendors[selectedIndex];

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showNewModal, setShowNewModal] = useState(false);

  const onCreate = (values) => {
    createVendor(values);
    setShowNewModal(false);
  };

  const onUpdate = (values) => {
    if (selected && selected.id) {
      updateVendor(selected.id, values);
    }
    setShowEditModal(false);
  };

  const onDelete = () => {
    if (selected && selected.id) {
      deleteVendor(selected.id);
    }
    // close all modals
    setShowDeleteModal(false);
    setShowEditModal(false);
    setShowNewModal(false);
  };

  return (
    <div style={{ display: "flex", width: "100%" }}>
      <LocationModal
        show={showNewModal}
        hide={() => setShowNewModal(false)}
        title="New Vendor"
        location={selected}
        onSave={onCreate}
        onDelete={() => setShowNewModal(false)}
      />

      <LocationModal
        show={showEditModal}
        hide={() => setShowEditModal(false)}
        title="Edit Vendor"
        location={selected}
        onSave={onUpdate}
        onDelete={() => setShowDeleteModal(true)}
      />

      <DeleteModal
        show={showDeleteModal}
        hide={() => setShowDeleteModal(false)}
        title="Delete Vendor"
        onDelete={onDelete}
      />

      <div style={{ width: "20%", padding: 20, paddingRight: 0 }}>
        <div
          style={{
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
            color: "white",
            marginBottom: 10,
            fontSize: 20,
          }}
          onClick={() => setShowNewModal(true)}
        >
          <AiOutlinePlusCircle style={{ marginRight: 10 }} /> New Vendor
        </div>

        <LocationList
          locations={vendors}
          selectedIndex={selectedIndex}
          onClick={(idx) => setSelectedIndex(idx)}
          onEdit={() => setShowEditModal(true)}
          onDelete={() => setShowDeleteModal(true)}
        />
      </div>

      <div style={{ width: "80%", padding: 20 }}>
        <GoogleMap
          locations={vendors}
          style={{ flexGrow: "1", height: "100%", borderRadius: 20 }}
          onClick={(idx) => setSelectedIndex(idx)}
        />
      </div>
    </div>
  );
};

export default Vendors;
